export default __webpack_public_path__ + "static/media/notWebHosting.60adb8e2.svg";